<ng-container *ngIf="action$ | async"></ng-container>

<div mat-dialog-title>
  <span i18n class="title dialog-title">Статистика по материалу</span>
  <button mat-button class="mat-icon-button" [mat-dialog-close] aria-label="Close dialog">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div mat-dialog-content fusePerfectScrollbar>
  <div *ngIf="data.boardsStatistic && data.boardsStatistic.length > 1" class="flex flex-col items-stretch">
    <mat-form-field class="no-label" appearance="outline">
      <mat-select [formControl]="statisticsForOneCard">
        <mat-option i18n [value]="-1">Общая статистика</mat-option>
        <mat-option i18n [value]="i" *ngFor="let boardStatistic of data.boardsStatistic; index as i"
          >Карта № {{ i + 1 }}</mat-option
        >
      </mat-select>
    </mat-form-field>
  </div>
  <table>
    <tr>
      <th i18n class="mat-body-2 text-left">Количество плит материала</th>
      <td class="mat-body-1">{{ showingStatistic?.countPlate | number : '1.0-3' }}</td>
    </tr>
    <tr>
      <th i18n class="mat-body-2 text-left">КИМ</th>
      <td class="mat-body-1">{{ showingStatistic?.KIM | percent : '1.0-2' }}</td>
    </tr>
    <tr>
      <th i18n class="mat-body-2 text-left">КИМ с учетом обрезков</th>
      <td class="mat-body-1">{{ getKIMWithCutOffs() | percent : '1.0-2' }}</td>
    </tr>
    <tr>
      <th i18n class="mat-body-2 text-left">Установок размеров</th>
      <td class="mat-body-1">{{ showingStatistic?.numberSize | number : '1.0-3' }}</td>
    </tr>
    <tr>
      <th i18n class="mat-body-2 text-left">Количество поворотов панелей</th>
      <td class="mat-body-1">{{ showingStatistic?.numberOfTurns | number : '1.0-3' }}</td>
    </tr>
    <tr>
      <th i18n class="mat-body-2 text-left">Количество резов</th>
      <td class="mat-body-1">{{ showingStatistic?.numberOfCuts | number : '1.0-3' }}</td>
    </tr>
    <tr>
      <th i18n class="mat-body-2 text-left">Длина резов</th>
      <td class="mat-body-1">{{ mm2m(showingStatistic?.lengthOfCuts) | number : '1.0-3' }} <span i18n>м</span></td>
    </tr>
    <tr>
      <th i18n class="mat-body-2 text-left">Количество панелей</th>
      <td class="mat-body-1">{{ showingStatistic?.numberDetails | number : '1.0-3' }}</td>
    </tr>
    <tr>
      <th i18n class="mat-body-2 text-left">Площадь панелей</th>
      <td class="mat-body-1">
        {{ squareMm2squareM(showingStatistic?.detailArea) | number : '1.0-3' }} <span i18n>м²</span>
      </td>
    </tr>
    <tr>
      <th i18n class="mat-body-2 text-left">Периметр панелей</th>
      <td class="mat-body-1">{{ mm2m(showingStatistic?.detailsPerimetr) | number : '1.0-3' }} <span i18n>м</span></td>
    </tr>
    <tr>
      <th i18n class="mat-body-2 text-left">Площадь использованных плит и обрезков</th>
      <td class="mat-body-1">
        {{ squareMm2squareM(showingStatistic?.boardsArea) | number : '1.0-3' }} <span i18n>м²</span>
      </td>
    </tr>
    <tr>
      <th i18n class="mat-body-2 text-left">Площадь поворачиваемых полос</th>
      <td class="mat-body-1">
        {{ squareMm2squareM(showingStatistic?.squareBandsRotate) | number : '1.0-3' }} <span i18n>м²</span>
      </td>
    </tr>
    <tr>
      <th i18n class="mat-body-2 text-left">Площадь обрезков</th>
      <td class="mat-body-1">
        {{ squareMm2squareM(showingStatistic?.squareScraps) | number : '1.0-3' }} <span i18n>м²</span>
      </td>
    </tr>
    <tr>
      <th i18n class="mat-body-2 text-left">Площадь всех отходов</th>
      <td class="mat-body-1">
        {{ squareMm2squareM(showingStatistic?.squareAllWaste) | number : '1.0-3' }} <span i18n>м²</span>
      </td>
    </tr>
    <tr>
      <th i18n class="mat-body-2 text-left">Площадь отходов</th>
      <td class="mat-body-1">
        {{ squareMm2squareM(showingStatistic?.squareWaste) | number : '1.0-3' }} <span i18n>м²</span>
      </td>
    </tr>
    <tr>
      <th i18n class="mat-body-2 text-left">Площадь резов</th>
      <td class="mat-body-1">
        {{ squareMm2squareM(showingStatistic?.squareCuts) | number : '1.0-3' }} <span i18n>м²</span>
      </td>
    </tr>
  </table>
</div>
<div mat-dialog-actions>
  <button i18n type="button" mat-button [mat-dialog-close]>ЗАКРЫТЬ</button>
</div>
